"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
exports.defaultCalendarModel = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment(moment().startOf('month')),
    endDate: moment(moment().endOf('month')),
    currentDate: moment(moment()),
    eventFilter: [],
    productionSeasonFilter: 0,
    filterFunction: function () { return true; },
    events: []
};
exports.calendarSettings = {
    loadWrappingMonthDates: false,
    saveHistory: false
};
exports.mockCalendarModel = {
    updating: false,
    specificDates: false,
    extendEvents: false,
    startDate: moment('2015-05-01').startOf('month'),
    endDate: moment('2015-05-02').endOf('month'),
    currentDate: moment('2015-05-01'),
    eventFilter: [],
    productionSeasonFilter: 0,
    filterFunction: function () { return true; },
    events: []
};
//# sourceMappingURL=calendar-state.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@adage/ace-calendar/app/classes/calendar-state.js
// module id = 42
// module chunks = 0